import { render, staticRenderFns } from "./CartItem.vue?vue&type=template&id=2c8c4cf2"
import script from "./CartItem.vue?vue&type=script&lang=js"
export * from "./CartItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/wp-content/themes/svea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c8c4cf2')) {
      api.createRecord('2c8c4cf2', component.options)
    } else {
      api.reload('2c8c4cf2', component.options)
    }
    module.hot.accept("./CartItem.vue?vue&type=template&id=2c8c4cf2", function () {
      api.rerender('2c8c4cf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/CartItem.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/CartItem.vue
// module id = 123
// module chunks = 0